<template>
  <div v-if="score && score > 0" class="compatibility-container">
    <span class="score">{{ score.toFixed(0) }} </span>
    <span class="compatible">Compatible</span>
  </div>
  <div
    v-else-if="score === null && characteristics !== null"
    class="compatibility-container"
  >
    <span class="score disabled">?</span>
    <span class="compatible disabled">
      <router-link
        class="compatibility-link"
        :to="{
          name: 'Finder',
        }"
      >
        Show Compatibility Score
      </router-link>
    </span>
  </div>
</template>

<script>
export default {
  name: "CompatibilityScore",
  props: ["score", "characteristics"],
};
</script>

<style scoped lang="scss">
.compatibility-container {
  position: absolute;
  bottom: 30px;
  overflow: hidden;
  z-index: 99;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  span {
    width: 110px;
    display: block;
    text-align: center;
    color: #fff;
    background: rgb(2, 0, 36);
    background: linear-gradient(
      90deg,
      rgba(154, 105, 203, 0.1) 0%,
      rgba(154, 105, 203, 1) 50%,
      rgba(154, 105, 203, 0.1) 100%
    );
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);

    &.score {
      font-weight: 600;
      font-size: 2rem;
      line-height: 1em;
      padding-top: 5px;

      &.disabled {
        font-size: 1.5rem;
        &::after {
          content: "";
        }
      }

      &::after {
        content: "%";
        font-weight: 400;
        font-size: 1rem;
        vertical-align: middle;
        margin-left: -5px;
      }
    }

    &.compatible {
      font-size: 0.85rem;
      font-weight: 600;
      text-transform: uppercase;
      padding-bottom: 5px;

      a {
        color: #fff !important;
      }

      &.disabled {
        font-size: 0.8rem;
      }
    }
  }
}
</style>
